function getDebugInfo() {
  var infoSections = [];
  var parser = new UAParser();
  var uastring1 = document.getElementById("text1").value;
    parser.setUA(uastring1);
    var result = parser.getResult();
  var userOs = parser.getOS();
  var userDevice = parser.getDevice();
  var userBrowser = parser.getBrowser();
  var debugContainer = document.getElementById("debug-container");

  if (userOs && userOs.name && userOs.version) {
    infoSections.push({ name: 'Operating System:', value: userOs.name + ' ' + userOs.version});
  }

  if (userBrowser && userBrowser.name && userBrowser.version) {
    infoSections.push({ name: 'Browser:', value: userBrowser.name + ' ' + userBrowser.version});
  }

  //Old-school JS without jQuery or another framework, just for fun
  while (debugContainer.hasChildNodes()) {
    debugContainer.removeChild(debugContainer.lastChild);
  }

  for (var i = 0; i < infoSections.length; i++) {
    var debugInfo = document.createElement("div");
    debugInfo.setAttribute("class", "debug-info");
    var debugName = document.createElement("div");
    debugName.setAttribute("class", "debug-name");
    debugName.appendChild(document.createTextNode(infoSections[i].name));
    var debugValue = document.createElement("div");
    debugValue.setAttribute("class", "debug-value");
    debugValue.appendChild(document.createTextNode(infoSections[i].value)); 
    debugInfo.appendChild(debugName);
    debugInfo.appendChild(debugValue);
    debugContainer.appendChild(debugInfo);
  }
}
getDebugInfo();